const MobileCategories = class extends HTMLElement {
  constructor() {
    super()

    this.swiper = null
    this.swiperEl = this.querySelector('[data-mobile-categories-swiper]')
    this.prev = this.querySelector('[data-mobile-categories-prev]')
    this.next = this.querySelector('[data-mobile-categories-next]')

    this.options = {
      centerInsufficientSlides: true,
      slidesPerView: 'auto',
      navigation: {
        nextEl: this.next,
        prevEl: this.prev
      },
      mousewheel: {
        enabled: true,
        forceToAxis: true
      },
      spaceBetween: 16,
      breakpoints: {
        768: {
          slidesPerView: 6
        },
        1440: {
          slidesPerView: 8
        }
      }
    }
  }

  connectedCallback() {
    this.swiper = new Swiper(this.swiperEl, this.options)
  }
}

if (typeof window.customElements.get('mobile-categories') === 'undefined') {
  window.customElements.define('mobile-categories', MobileCategories)
}
